export default __webpack_public_path__ + "static/media/ql_06.9dceb4da.png";